// =========================================================== //
// ===================== SLIDER CLONE ======================= //
// =========================================================== //

function cloneFirstSlide() {
  const sliders = document.querySelectorAll('.gdc-slider-image-text-split')

  sliders.forEach(slider => {
    const slidesContainer = slider.querySelector('.gdc-slider-image-text-split__slider')
    const slides = slider.querySelectorAll('.gdc-slider-image-text-split__slide')
    const clone = slides[0].cloneNode(true)

    clone.setAttribute('clone', 0)
    slidesContainer.appendChild(clone)

  })
}

window.addEventListener('DOMContentLoaded', cloneFirstSlide)

 
 // =========================================================== //
// ===================== SLIDER BUTTONS ======================= //
// =========================================================== //

 function handleSliderTextImage(evt) {
    const _s = {

      slider: () => evt.target
                    .closest('.gdc-slider-image-text-split')
                    .querySelector('.gdc-slider-image-text-split__slider'),
      originalSlides: () => _s.slider().querySelectorAll('.gdc-slider-image-text-split__slide:not([clone])'),
      sliderScrollPosition: () => _s.slider().scrollLeft,
      numberOfOriginalSlides: () => _s.originalSlides().length,
      slideWidth: () => _s.originalSlides()[0].offsetWidth,
      totalWidthOriginalSlides: () => _s.slideWidth() * _s.numberOfOriginalSlides(),
      slideAmount: () => window.innerWidth,   
      direction: () => evt.target.dataset.direction,
      firstClone: () => _s.slider().querySelector('[clone="0"]'),
      firstSlide: () => _s.originalSlides()[0],
      handleScroll: () => _s.direction() === 'left' ? _s.scrollLeft() : _s.scrollRight(),
      scrollRight: () => _s.slider().scrollBy({left: _s.slideAmount(), behavior: 'smooth'}),

      scrollLeft: () => {        
        if (_s.firstSlide().getBoundingClientRect().left === 0) {
          _s.slider().scrollTo({left: _s.totalWidthOriginalSlides() -10})
          _s.slider().scrollBy({left: -_s.slideAmount(), behavior: 'smooth'})
        } else {
          _s.slider().scrollBy({left: -_s.slideAmount(), behavior: 'smooth'})
        }
      }
    }

    _s.handleScroll()
 }


  // =========================================================== //
 // ==================== HANDLES RIGHT CLICK LOOPING ========== //
// =========================================================== //

 function handleTextImageRightLooping() {
   const _s = {
     slider: () => document.querySelector('.gdc-slider-image-text-split__slider'),
     firstClone: () => _s.slider().querySelector('[clone="0"]'),
     sliderLoopRight: () => {
        if (_s.firstClone().getBoundingClientRect().left === 0) _s.slider().scrollTo({left: 0})
      }
  }
  if (_s.slider()) _s.slider().addEventListener('scroll', _s.sliderLoopRight)
}

window.addEventListener('DOMContentLoaded', handleTextImageRightLooping)


  // =========================================================== //
 // ==================== HANDLES SLIDER ANIMATION ============= //
// =========================================================== //

function animateSlides() {
  const animatedSliders = document.querySelectorAll('.gdc-slider-image-text-split[data-animated="true"]')
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const _s = {
          nextButton: () => entry.target.querySelector('.gdc-slider-image-text-split__slider-controls-arrow[data-direction="right"]'),
          slideChangeDelay: () => parseInt(_s.nextButton().dataset.timerDelay) * 1000,
          clickNext: () => _s.nextButton().click()
        }
        
        setInterval(_s.clickNext, _s.slideChangeDelay());
        observer.unobserve(entry.target)

      }
    })
  })
  
  animatedSliders.forEach(slider => {
    observer.observe(slider)
  })
  
 }

 window.addEventListener('DOMContentLoaded', animateSlides)

